/**
 * Theme Registry
 * Centralized theme management and registration
 */

import { ThemeConfig } from '../types';
import silverFallsCapitalTheme from './silver-falls-capital';
import sportworksTheme from './sportworks';

// Available themes registry
export const availableThemes: Record<string, ThemeConfig> = {
  'silver-falls-capital': silverFallsCapitalTheme,
  'sportworks': sportworksTheme,
};

// Default theme
export const DEFAULT_THEME_NAME = 'silver-falls-capital';
export const DEFAULT_THEME_MODE = 'light';

// Get theme by name
export function getTheme(themeName: string): ThemeConfig {
  return availableThemes[themeName] || availableThemes[DEFAULT_THEME_NAME];
}

// Get all available theme names
export function getAvailableThemeNames(): string[] {
  return Object.keys(availableThemes);
}

// Get all available themes
export function getAllThemes(): ThemeConfig[] {
  return Object.values(availableThemes);
}

// Check if theme exists
export function themeExists(themeName: string): boolean {
  return themeName in availableThemes;
}

// Register a new theme (for dynamic theme loading)
export function registerTheme(theme: ThemeConfig): void {
  availableThemes[theme.id] = theme;
}

// Unregister a theme
export function unregisterTheme(themeName: string): void {
  if (themeName !== DEFAULT_THEME_NAME) {
    delete availableThemes[themeName];
  }
}

// Export individual themes for direct import
export {
  silverFallsCapitalTheme,
  sportworksTheme,
};